import React from 'react';

const NotificationIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="white" {...props}>
      <g opacity="0.2">
        <path d="M22 36C23.8921 36 25.427 34.4332 25.427 32.5H18.573C18.573 34.4332 20.1079 36 22 36ZM33.5387 27.8127C32.5037 26.6774 30.5671 24.9695 30.5671 19.375C30.5671 15.1258 27.6486 11.7242 23.7132 10.8897V9.75C23.7132 8.78367 22.9461 8 22 8C21.0539 8 20.2868 8.78367 20.2868 9.75V10.8897C16.3514 11.7242 13.4329 15.1258 13.4329 19.375C13.4329 24.9695 11.4963 26.6774 10.4613 27.8127C10.1399 28.1655 9.99736 28.5871 10 29C10.0059 29.8969 10.6954 30.75 11.7197 30.75H32.2803C33.3046 30.75 33.9946 29.8969 34 29C34.0026 28.5871 33.8601 28.1649 33.5387 27.8127Z" />
      </g>
    </svg>
  );
};

export default NotificationIcon;